import * as React from "react";
import "../../../style/footer.css";
import "../../../style/App.css";
import appstore from "../../../icons/appstore.png";
import playstore from "../../../icons/playstore.png";
import translate from "../../../translations/i18n";

const Footer1 = () => {
  return (
    <div className="FOOTER_1">
      <div className="GET">
        <div className="TITLE_1">{translate("DOWNLOAD_SECTION_TITLE")}</div>
      </div>
      <div className="STORE_BUTTONS">
        <div className="APPSTORE">
          <img src={appstore} />
        </div>
        <div className="PLAYSTORE">
          <img src={playstore} />
        </div>
      </div>
    </div>
  );
};

export default Footer1;



// WEBPACK FOOTER //
// ./src/components/layout/Footer/Footer1.tsx